.HeaderContainer
    width: 100%
    margin: 0
    padding: 0
    color: rgb($globalSettingsFontPrimary)
    display: flex
    align-items: center
    justify-content: space-between
    clear: both
    box-sizing: border-box
    p
        margin: 0

.HeaderTitle
    font-size: 24px
    line-height: 1.4
    display: inline-block
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    

.RightContainer
    display: flex
    flex-direction: row
    align-items: center
    margin-left: 10px
    max-width: 50%
    .ExpirationContainer
        color: rgb($globalSettingsFontTertiary)
        font-size: 12px
        margin-right: 10px
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
    div
        display: flex
        align-items: center
